#import "../../list/DataAccessPolicyFields.graphql"

mutation DataAccessPolicyCreate($input: DataAccessPolicyCreateInput!) {
  dataAccessPolicyCreate(input: $input) {
    dataAccessPolicy {
      ...DataAccessPolicyFields
    }
  }
}
